import axios from 'axios';
import { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { Modal, Spinner } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { FaRegCircleCheck, FaWhatsapp } from 'react-icons/fa6';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { SlArrowLeft } from 'react-icons/sl';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import '../../../jsx/Dashborad/dashboard.css';
import CivilButton from '../../ReusableComponent/CIVIL/CivilButton/CivilButton';
import NeetPaymentModal from './NeetPaymentModal';
// import PaymentModal from '../PaymentService/PaymentModal';
function DynamicTestSeriesHome() {
    const navigate = useNavigate();
    const location = useLocation()
    const { subject, subjectId } = location?.state || {};
    console.log(subject, subjectId);
    const alert = useAlert();

    const [open, setOpen] = useState(false);
    const [openPaymentProccessingModal, setPaymentProccessingModal] = useState(false);
    const email = localStorage.getItem("authtoken")
    const [testPlans, setTestPlans] = useState([])
    const [selectedTest, setSelectedTest] = useState({ Sn: 1, TestCount: 5, Price: 500, Discount: 0 });
    const [tests, setTests] = useState([]);
    const [subjectSpecificData, setSubjectSpecificData] = useState({});
    const [subjects, setSubjects] = useState([]);
    const [openPaymentSuccessModal, setPaymentSuccessModal] = useState(false);
    const [transactionId, setTransactionId] = useState('');
    const [selectedClass, setSelectedClass] = useState({ value: 'Class-11', label: 'Class-11' });
    const enrolled = transactionId.length > 0 ? true : false;
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [plansRes, subjectsRes, specificDataRes] = await Promise.all([
                    axios.get(BASE_URL + `/neet/user/test-plans`),
                    axios.get(BASE_URL + `/neet/user/subjects`),
                    axios.get(BASE_URL + `/neet/user/subject-specific-data/${subjectId}`)
                ]);
                setTestPlans(plansRes.data.data);
                setSelectedTest(plansRes.data.data[0]);
                setSubjects(subjectsRes.data.data);
                setSubjectSpecificData(specificDataRes.data.data[0]);
            } catch (error) {
                console.log(error);
            }
        }
        if (!subjectId) return;
        fetchInitialData()
    }, [subjectId]);
    useEffect(() => {
        const matchingPlans = testPlans?.filter(plan => plan.Section === selectedClass.value && plan.SubjectID == subjectId);
        if (matchingPlans && matchingPlans.length > 0) {
            setSelectedTest(matchingPlans[0]);
        } else {
            setSelectedTest({ Sn: 0, TestCount: 0, Price: 0, Discount: 0 });
        }
    }, [testPlans, selectedClass, subjectId]);

    useEffect(() => {
        if (selectedTest.TestCount > 0) {
            setTests(new Array(selectedTest.TestCount).fill(1));
        } else {
            setTests([]);
        }
    }, [selectedTest.Sn])

    const testSeriesPrice = selectedTest?.Price.toLocaleString('en-IN');
    const priceAfterDiscount = selectedTest.Price - (selectedTest.Price * (selectedTest.Discount / 100))
    const payableAmount = Math.ceil(priceAfterDiscount);
    const handleEnroll = () => {
        if (email) {
            setOpen(true);
        } else {
            navigate('/login');
        }
    }
    return (
        <>
            <Helmet>
                <title>{"CUET|Seciton-IA"}</title>
                {/* <meta name="description" content={`${testSeriesData.MetaDescription}`}></meta> */}
            </Helmet>
            {/* Civil Test Page Start */}
            <div className='Dashboard-background'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='col-lg-3 col-md-12 col-sm-12 dashboardmain-left p-3'>
                            <div className='dashboardleft-background'>
                                <div className='dash1'>
                                    {subjectSpecificData?.Thumbnail ? (
                                        <div className="premium-img-wrapper">
                                            <img src={subjectSpecificData.Thumbnail} className='premium-img-bg' alt="Background" />
                                            <img src={subjectSpecificData.Thumbnail} className='premium-img-overlay' alt={subject || "Subject Thumbnail"} />
                                        </div>
                                    ) : (
                                        <div className='dash2-img-placeholder'>
                                            NEET - {subject}
                                        </div>
                                    )}
                                </div>
                                <div className='dash2'>
                                    <div className="d-grid gap-2">
                                        <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, moduleName: 'neet' }} className="btn d-flex align-items-center justify-content-center btn-orange fw-bold py-3" type="button" style={{ letterSpacing: '0.5px', fontSize: '1.05rem' }}>Dashboard</Link>
                                        
                                       

                                        <div className="border border-2 rounded border-gray">
                                            <label htmlFor="select_subj" className='btn_custom_class btn d-flex align-items-center justify-content-center fw-bold text-white text-uppercase' style={{ cursor: 'default' }}>Choose your Subject</label>
                                            <Select
                                                id='select_subj'
                                                value={{ value: subjectId, label: subject }}
                                                onChange={(selectedOption) => {
                                                    navigate(`/neet/dynamic-testseries/${selectedOption.label}`, { state: { subject: selectedOption.label, subjectId: selectedOption.value } });
                                                }}
                                                options={subjects?.map((item) => ({ value: item.Sn, label: item.Subject }))}
                                                styles={{
                                                    control: (provided) => ({ ...provided, textAlign: 'center', cursor: 'pointer', borderColor: '#17a2b8' }),
                                                    option: (provided) => ({ ...provided, cursor: 'pointer', textAlign: 'center' }),
                                                    singleValue: (provided) => ({ ...provided, textAlign: 'center' })
                                                }}
                                            />
                                        </div>


                                         <div className="border border-2 rounded border-gray">
                                            <label htmlFor="select_class" className='btn_custom_class btn d-flex align-items-center justify-content-center fw-bold text-white text-uppercase' style={{ cursor: 'default' }}>Choose your Class</label>
                                            <Select
                                                id='select_class'
                                                value={selectedClass}
                                                onChange={(selectedOption) => setSelectedClass(selectedOption)}
                                                options={[
                                                    { value: 'Class-11', label: 'Class-11' },
                                                    { value: 'Class-12', label: 'Class-12' }
                                                ]}
                                                styles={{
                                                    control: (provided) => ({ ...provided, textAlign: 'center', cursor: 'pointer', borderColor: '#17a2b8' }),
                                                    option: (provided) => ({ ...provided, cursor: 'pointer', textAlign: 'center' }),
                                                    singleValue: (provided) => ({ ...provided, textAlign: 'center' })
                                                }}
                                            />
                                        </div>

                                        <div className="border border-2 rounded border-gray">
                                            <label htmlFor="select_test" className='btn_custom_class btn d-flex align-items-center justify-content-center fw-bold text-white text-uppercase' style={{ cursor: 'default' }}>Select Number of Tests</label>
                                            <Select
                                                id='select_test'
                                                value={selectedTest?.Sn ? { value: selectedTest, label: selectedTest.TestCount + " Tests" } : null}
                                                onChange={(selectedOption) => setSelectedTest(selectedOption.value)}
                                                options={testPlans?.filter(plan => plan.Section === selectedClass.value && plan.SubjectID == subjectId).map((item) => ({ value: item, label: item.TestCount + " Tests" }))}
                                                styles={{
                                                    control: (provided) => ({ ...provided, textAlign: 'center', cursor: 'pointer', borderColor: '#17a2b8' }),
                                                    option: (provided) => ({ ...provided, cursor: 'pointer', textAlign: 'center' }),
                                                    singleValue: (provided) => ({ ...provided, textAlign: 'center' })
                                                }}
                                                placeholder={testPlans?.filter(plan => plan.Section === selectedClass.value && plan.SubjectID == subjectId).length > 0 ? "Select Tests" : "No Plans Found"}
                                            />
                                        </div>

                                        <button
                                            onClick={handleEnroll}
                                            className="btn btn-orange w-100 py-3 d-flex flex-column align-items-center justify-content-center shadow-sm"
                                            type="button"
                                            style={{ borderRadius: '8px', border: 'none' }}
                                        >
                                            {selectedTest?.Sn && subjectId ? (
                                                <>
                                                    <div className='d-flex align-items-center justify-content-center flex-wrap gap-2 mb-1' style={{ opacity: 0.9 }}>
                                                        <span className='text-decoration-line-through text-uppercase underline-offset-2' style={{ fontSize: '0.9rem', letterSpacing: '0.5px' }}>
                                                            FEE ₹{selectedTest?.Price?.toLocaleString('en-IN')}
                                                        </span>
                                                        <span className='fw-bold text-uppercase' style={{ fontSize: '0.85rem', background: 'rgba(255,255,255,0.25)', padding: '2px 10px', borderRadius: '4px' }}>
                                                            {selectedTest?.Discount || 0}% OFF
                                                        </span>
                                                        <span className='fw-bold' style={{ fontSize: '0.9rem' }}>
                                                            PAY JUST ₹{payableAmount?.toLocaleString('en-IN')}
                                                        </span>
                                                    </div>
                                                    <div className='fw-bold text-uppercase' style={{ fontSize: '1.2rem', letterSpacing: '1.5px', textShadow: '0 1px 2px rgba(0,0,0,0.2)' }}>
                                                        {payableAmount < 1 ? 'ENROLL FOR FREE' : `₹${payableAmount?.toLocaleString('en-IN')} ENROLL NOW`}
                                                    </div>
                                                </>
                                            ) : (
                                                <div className='fw-bold text-uppercase' style={{ fontSize: '1.25rem', letterSpacing: '1.5px' }}>
                                                    ENROLL NOW
                                                </div>
                                            )}
                                        </button>

                                        <Link to="https://api.whatsapp.com/send?phone=919818333201" target='_blank' className="btn d-flex align-items-center justify-content-center btn-whatsapp fw-bold py-3" type="button" style={{ letterSpacing: '0.5px', fontSize: '1.05rem' }}><FaWhatsapp className='me-1 fs-4' /> WHATSAPP 9818333201</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-9 col-md-12 col-sm-12'>
                            <div className="d-flex justify-content-between align-items-center p-2 py-1 mb-3 bg-light border rounded shadow-sm">
                                <button
                                    className="btn btn-sm"
                                    style={{
                                        backgroundColor: '#17a2b8',
                                        color: 'white',
                                        fontWeight: 'bold',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px',
                                        padding: '4px 12px',
                                        border: 'none',
                                        borderRadius: '4px',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => navigate(-1)}
                                >
                                    <SlArrowLeft /> Back
                                </button>
                                <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>{subject} Tests</h2>
                                <Link to={'/StudentDashboard'} state={{ prePath: location.pathname, moduleName: 'neet' }} style={{ textDecoration: 'none', color: '#17a2b8', fontWeight: 'bold' }}>Dashboard</Link>
                            </div>
                            <CivilButton componentName={subject + "_Tests"} Neet_Subject={subject} NEET_Tests={tests} overView={subjectSpecificData.Description} enrolled={enrolled} />
                        </div> 
                    </div>
                </div>
            </div>
            <Modal show={open} centered className="animate__animated animate__fadeIn mobileyoutube">
                <NeetPaymentModal setOpen={setOpen} Amount={payableAmount} TestCount={selectedTest.TestCount} SubjectID={subjectId} Section={selectedClass.value} setPaymentProccessingModal={setPaymentProccessingModal} SubjectType={subject} setTransactionId={setTransactionId} setPaymentSuccessModal={setPaymentSuccessModal} />
            </Modal>
            <Modal show={openPaymentProccessingModal} top backdrop="static" dialogClassName="custom-modal-width">
                <div className="modal-content" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className="modal-body" style={{ padding: "2rem" }}>
                        <div className="mb-3 d-block text-center">
                            <Spinner
                                animation="border"
                                className="mt-5 mb-3"
                                size="xl"
                                style={{ width: "200px", height: "200px", color: "#ff2f00" }}

                            />
                            <h5
                                className="modal-title mb-5"
                                id="exampleModalLabel"
                                style={{ color: "#17a2b8", fontFamily: "Arial, sans-serif" }}
                            >
                                Saving Order Details. This may take a moment...
                            </h5>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal show={openPaymentSuccessModal} top backdrop="static" dialogClassName="" size="lg" centered>
                <div className="" style={{ backgroundColor: "#f0f8ff", padding: "2rem", borderRadius: "10px" }}>
                    <div className='p-5 py-3 d-flex justify-content-center align-items-center' >
                        <div className='text-black text-center'>
                            <FaRegCircleCheck className='text-orange' style={{ fontSize: "15vmax" }} />
                            <h1 className='py-2 fw-bold text-success'>Payment Successful</h1>
                            <h4 className='text-info'>Your order has been placed Successfully</h4>
                            <h6 > <span style={{ fontWeight: "700" }}>Program Enrolled</span> : NEET - {subject}</h6>
                            <h6 ><span style={{ fontWeight: "700" }}>Payment ID</span> : {transactionId}</h6>

                            {/* <h6>Payment ID:</h6> */}
                            {/* <h6>{paymentdetail[0].TranscationID}</h6> */}
                            <div className='p-3 d-flex justify-content-center'>
                                <button onClick={() => setPaymentSuccessModal(false)} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4' >
                                    done
                                </button>
                                {/* <Link to={`/cuet/${ExamType.toLowerCase()}`} state={{ enrolled: true }} style={{ textDecoration: "none" }} className='bg-orange text-white py-2 rounded-pill fs-6 px-4' >
                                                                done
                                                            </Link> */}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            {/* Civil Test Page End */}
        </>
    )
}

export default DynamicTestSeriesHome;



